import { ref } from 'vue';

const isTokenAuthInProgress = ref(false);
const tokenAuthPromise = ref<Promise<void> | null>(null);

export const startTokenAuth = () => {
  isTokenAuthInProgress.value = true;
};

export const completeTokenAuth = () => {
  isTokenAuthInProgress.value = false;
  tokenAuthPromise.value = null;
};

export const setTokenAuthPromise = (promise: Promise<void>) => {
  tokenAuthPromise.value = promise;
};

export const useTokenAuthState = () => ({
  isTokenAuthInProgress: readonly(isTokenAuthInProgress),
  tokenAuthPromise: readonly(tokenAuthPromise),
});

export const waitForTokenAuth = async (): Promise<void> => {
  if (tokenAuthPromise.value) {
    try {
      await tokenAuthPromise.value;
    } catch (error) {
      console.error('Token authentication failed:', error);
    }
  }
};
